
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    WoSLAHistory, WOPriority, SLAEntity, Wo_JobDetails
} from '../../work-order/work-order-models';
import { FPMessage, Severities, PageKey, RoleAccess, SourceSystem } from '../../shared/shared.model';
import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { PopupInit } from '../../shared/init-popup';
import { DatePipe } from '@angular/common';
import { Message, ConfirmationService } from 'primeng/primeng';

import { BaseComponent } from '../../shared/base.component';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { LoaderService } from '../.././shared/loader.service';
@Component({
    // moduleId: module.id,
    selector: 'edit-sla-detail-popup',
    templateUrl: 'edit-sla-detail-popup.component.html'

})


export class EditSlaDetailPopUpComponent extends BaseComponent implements OnInit {

    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;
    @Input() WojobId: number;
    @Input() WoId: number;
    @Input() PriorityId: number;
    @Input() Color: string;
    @Input() isSLAApplied: number;
    // WojobId:number;
    iseditlookup: boolean = false;
    @Output() done = new EventEmitter();
    public isSaveAttempt: boolean;
    message: FPMessage;
    //EQUIPMENT SLA START CR--Balamurugan Added 07/12/2017
    priorities: WOPriority[];
    prioritiesdataSource: WOPriority[];
    slaEntity: SLAEntity;
    valuecolor: string;
    SetpriorityId: any;
    prioritySelected: number;
    priorityId: number = 0;
    slastartsfrom: number = 0;
    sladuration: number = 0;
    //EQUIPMENT SLA END CR--Balamurugan Added 07/12/2017
    frmSLA: FormGroup;
    ischangeByCustomer: number = 0;
    Wo_JobDetails: Wo_JobDetails[];
    constructor(protected translateService: TranslateService, protected _woService: WoService,
        private formBuilder: FormBuilder, private route: ActivatedRoute,
        private datePipe: DatePipe, protected sharedService: SharedService, private loaderservice: LoaderService, private _fb: FormBuilder) {
        super(sharedService, translateService)

    }
    ngOnInit() {

        this.frmSLA = this._fb.group({
            WoJobId: [this.WojobId],
            priorityId: [0, Validators.required],
            //    Duration:[0]
        });
        if (this.WojobId) {
            this.frmSLA.patchValue(
                {
                    WoJobId: this.WojobId,
                    //       piPriorityID:this.PriorityId,

                }

            )


        }
        //EQUIPMENT SLA START CR--Balamurugan Added 07/12/2017

        this._woService.getPriorities(this.globalInfo().CompanyId).subscribe(resps => {

            var defflag = 0;
            this.priorities = resps;
            this.prioritiesdataSource = this.priorities.filter(x => x.IsActive == 1)
            this.prioritiesdataSource.forEach(data => {

                if (data.IsActive == 1) {
                    // data.Description = "";
                    // if (data.SlaDays != null)
                    //     data.Description = data.SlaDays + " days ";
                    // if (data.SlaHours != null)
                    //     data.Description += data.SlaHours + " hrs ";
                    // if (data.SlaMinutes != null)
                    //     data.Description += data.SlaMinutes + " mins ";

                    data.Description = "";
                    data.respreslstring = "";
                    data.SLADropdownlist = "";
                    if (data.IsResponseSlaEnabled == 1 && data.IsResolutionSlaEnabled == 1) {
                        if (data.RespSLADurationTypeId == 1 && data.ReslSLADurationTypeId == 1) {
                            if (data.SlaDays != null)
                                data.Description = data.SlaDays + " days ";
                            if (data.SlaHours != null)
                                data.Description += data.SlaHours + " hrs ";
                            if (data.SlaMinutes != null)
                                data.Description += data.SlaMinutes + " mins ";

                            if (data.ResponseSlaDays != null)
                                data.respreslstring = data.ResponseSlaDays + " days ";
                            if (data.ResponseSlaHours != null)
                                data.respreslstring += data.ResponseSlaHours + " hrs ";
                            if (data.ResponseSlaMinutes != null)
                                data.respreslstring += data.ResponseSlaMinutes + " mins ";

                            data.SLADropdownlist = ' (Response : ' + data.respreslstring + ',' + ' Resolution : ' + data.Description + ')';

                        }
                        else if (data.RespSLADurationTypeId != 1 && data.ReslSLADurationTypeId != 1) {
                            if (data.RespSLADurationTypeId != null) {
                                data.respreslstring = data.RespSLADurationType;
                            }
                            if (data.ReslSLADurationTypeId != null) {
                                data.Description = data.ReslSLADurationType;
                            }
                            data.SLADropdownlist = ' (Response : ' + data.respreslstring + ',' + ' Resolution : ' + data.Description + ')';
                        }
                        else if (data.RespSLADurationTypeId == 1 && data.ReslSLADurationTypeId != 1) {
                            if (data.ResponseSlaDays != null)
                                data.respreslstring = data.ResponseSlaDays + " days ";
                            if (data.ResponseSlaHours != null)
                                data.respreslstring += data.ResponseSlaHours + " hrs ";
                            if (data.ResponseSlaMinutes != null)
                                data.respreslstring += data.ResponseSlaMinutes + " mins ";

                            if (data.ReslSLADurationTypeId != null) {
                                data.Description = data.ReslSLADurationType;
                            }
                            data.SLADropdownlist = ' (Response : ' + data.respreslstring + ',' + ' Resolution : ' + data.Description + ')';
                        }
                        else if (data.RespSLADurationTypeId != 1 && data.ReslSLADurationTypeId == 1) {
                            if (data.RespSLADurationTypeId != null) {
                                data.respreslstring = data.RespSLADurationType;
                            }

                            if (data.SlaDays != null)
                                data.Description = data.SlaDays + " days ";
                            if (data.SlaHours != null)
                                data.Description += data.SlaHours + " hrs ";
                            if (data.SlaMinutes != null)
                                data.Description += data.SlaMinutes + " mins ";
                        }
                        data.SLADropdownlist = ' (Response : ' + data.respreslstring + ',' + ' Resolution : ' + data.Description + ')';

                    }
                    else {
                        if (data.IsResponseSlaEnabled == 1) {
                            if (data.RespSLADurationTypeId == 1) {
                                if (data.ResponseSlaDays != null)
                                    data.respreslstring = data.ResponseSlaDays + " days ";
                                if (data.ResponseSlaHours != null)
                                    data.respreslstring += data.ResponseSlaHours + " hrs ";
                                if (data.ResponseSlaMinutes != null)
                                    data.respreslstring += data.ResponseSlaMinutes + " mins ";
                            }
                            else if (data.RespSLADurationTypeId != 1) {
                                data.respreslstring = data.RespSLADurationType;
                            }
                            data.SLADropdownlist = ' (Response : ' + data.respreslstring + ')';

                        }
                        else if (data.IsResolutionSlaEnabled == 1) {
                            if (data.ReslSLADurationTypeId == 1) {
                                if (data.SlaDays != null)
                                    data.respreslstring = data.SlaDays + " days ";
                                if (data.SlaHours != null)
                                    data.respreslstring += data.SlaHours + " hrs ";
                                if (data.SlaMinutes != null)
                                    data.respreslstring += data.SlaMinutes + " mins ";
                            }
                            else if (data.ReslSLADurationTypeId != 1) {
                                data.respreslstring = data.ReslSLADurationType;
                            }
                            data.SLADropdownlist = ' (Resolution : ' + data.respreslstring + ')';

                        }

                    }

                }
                if (data.IsDefault == 1) {
                    defflag++;
                }


            });
            if (defflag > 0) {
                this.prioritySelected = this.prioritiesdataSource.find(a => a.IsDefault == 1).PriorityId;
                this.valuecolor = this.prioritiesdataSource.find(a => a.IsDefault == 1).Color;
                this.priorityId = this.prioritiesdataSource.find(a => a.IsDefault == 1).PriorityId;
                
            }
            if (this.PriorityId != 0) {
                this.prioritySelected = this.prioritiesdataSource.find(a => a.PriorityId == this.PriorityId).PriorityId;
                this.valuecolor = this.prioritiesdataSource.find(a => a.PriorityId == this.PriorityId).Color;
                this.priorityId = this.prioritiesdataSource.find(a => a.PriorityId == this.PriorityId).PriorityId;

                //  this.valuecolor=this.Color;
            }
            else {
                this.valuecolor = '#ffffff';
            }

            if (this.WojobId) {
                this.frmSLA.patchValue(
                    {

                        priorityId: this.PriorityId

                    }

                )
            }



        });


        //EQUIPMENT SLA END CR--Balamurugan Added 07/12/2017
    }


    //EQUIPMENT SLA START CR--Balamurugan Added 07/12/2017
    onprioritiesChange(val) {
        this.priorityId = val;
        this.ischangeByCustomer = 1;
        if (val != 0) {
            this.valuecolor = this.priorities.find(a => a.PriorityId == this.priorityId).Color;
        }
        else {
            this.valuecolor = '';
        }
    }

    //EQUIPMENT SLA END CR--Balamurugan Added 07/12/2017

    closePopup() {

        this.done.emit(0);
    }
    saveSLA(sla: SLAEntity, formValid: boolean) {        
        this.isSaveAttempt = true;
        if (formValid) {
            sla.piCompanyid = this.globalInfo().CompanyId;
            sla.piloginid = this.globalInfo().LoginId;
            if (this.frmSLA.controls["priorityId"].value != 0) {
                sla.piPriorityID = this.frmSLA.controls["priorityId"].value;
            }
            sla.piJobId = this.WojobId;
            sla.piAutoProcess = 0;
            if (this.ischangeByCustomer == 1) {
                sla.piIsChangedbycustomer = 1;
                sla.piSLAApplied = 0
            }
            else {
                sla.piIsChangedbycustomer = 0;
                sla.piSLAApplied = this.isSLAApplied;
            }
            sla.PiSourceId = SourceSystem.Web;


            if (this.ischangeByCustomer == 1) {
                this.loaderservice.show();
                if (sla.piPriorityID != undefined && sla.piPriorityID != null && sla.piPriorityID != 0) {
                    let slastartcheck = this.prioritiesdataSource.find(a => a.PriorityId == sla.piPriorityID).SlaStartsFrom;
                    let respstartcheck = this.prioritiesdataSource.find(a => a.PriorityId == sla.piPriorityID).ResponseSlaStartsFrom;
                    slastartcheck = slastartcheck == 31 ? 1 : 0;
                    respstartcheck = respstartcheck == 31 ? 1 : 0;
                    let isslafrom = slastartcheck + respstartcheck;
                    if (isslafrom > 0) {
                        this._woService.getWoJobDetails(this.globalInfo().CompanyId, this.WoId).subscribe(res => {
                            this.Wo_JobDetails = res.filter(m => m.WoJobId == this.WojobId);

                            if (this.Wo_JobDetails.find(x => x.ApptPrefDate == null)) {

                                this.sharedService.notification.emit({
                                    severity: Severities[2],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                                    detail: this.translate.instant('7004')
                                });
                                this.loaderservice.hide();
                            }
                            else {
                                this._woService.SaveSla(sla)
                                    .subscribe(s => {
                                        this.message = s.Message;
                                        this.sharedService.emitAuditlog.emit({ auditMessage: "SlaDetails" });
                                        this.sharedService.notification.emit({ severity: Severities[this.message.Severity], summary: this.translate.instant('9000') });
                                        if (s.Message.Severity == Severities.success) {
                                            this.closePopup();
                                        }
                                        else {
                                            this.closePopup();

                                        }
                                        this.loaderservice.hide();
                                    });
                            }

                        })
                    }
                    else {
                        this._woService.SaveSla(sla)
                            .subscribe(s => {
                                this.message = s.Message;
                                this.sharedService.emitAuditlog.emit({ auditMessage: "SlaDetails" });
                                this.sharedService.notification.emit({ severity: Severities[this.message.Severity], summary: this.translate.instant('9000') });
                                if (s.Message.Severity == Severities.success) {
                                    this.closePopup();
                                }
                                else {
                                    this.closePopup();

                                }
                                this.loaderservice.hide();
                            });
                    }
                }
                else {
                    this._woService.SaveSla(sla)
                        .subscribe(s => {
                            this.message = s.Message;
                            this.sharedService.emitAuditlog.emit({ auditMessage: "SlaDetails" });
                            this.sharedService.notification.emit({ severity: Severities[this.message.Severity], summary: this.translate.instant('9000') });
                            if (s.Message.Severity == Severities.success) {
                                this.closePopup();
                            }
                            else {
                                this.closePopup();

                            }
                            this.loaderservice.hide();
                        });
                }
            }
            else {
                this.closePopup();
            }
        }
    }

    responceMessage(res: any) {

        //   this.loader = false;
        this.message = res.Message;
        if (res.Message.Severity == Severities.success) this.closePopup(); else this.closePopup();
    }

}




